import styled from 'styled-components';

export const Row = styled.div`
  margin-top: 24px;
  padding: 0 20px;
  border-bottom: 5px solid #e9edf0;
`;
